import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { GENDER_SELECT_ITEM, Patient } from 'entities/patient'
import { ReactNode, useMemo } from 'react'
import { Form } from 'utils/hooks'
import { PatientViewModel } from 'view_models/patient_view_model'

export const patientColumnInfoList = (form?: Form<Record<string, unknown>>, admin?: boolean): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, width: 60, form: form, orderAttr: 'patient_id', searchType: { name: 'id', type: 'multiple_text' } },
            { name: 'ユーザーコード', th: true, width: 140, form: form, orderAttr: 'patient_code', searchType: { name: 'code', type: 'text' } },
            { name: '名前', th: true, width: 120, form: admin ? form : undefined, orderAttr: 'patient_name', searchType: { name: 'name', type: 'text' } },
            { name: '検査回数', th: true, width: 70, align: 'center' },
            {
                name: '性別',
                th: true,
                width: 60,
                align: 'center',
                form: admin ? form : undefined,
                orderAttr: 'patient_gender',
                searchType: { name: 'gender', type: 'multiple_select', selectItems: GENDER_SELECT_ITEM },
            },
            {
                name: '年齢',
                th: true,
                width: 60,
                align: 'center',
            },
            {
                name: '生年月日',
                th: true,
                width: 90,
                form: admin ? form : undefined,
                orderAttr: 'patient_birthday',
                searchType: { name: 'birthday', type: 'date' },
                align: 'center',
            },
            {
                name: '住所',
                th: true,
                minWidth: 300,
                form: admin ? form : undefined,
                orderAttr: 'patient_address_id',
                searchType: { name: 'address', type: 'text' },
            },
        ],
    }
}

export type PatientTableDataProps = {
    patient?: Patient
    displaySetting: DisplaySetting
    admin?: boolean
}

export const PatientTableData = ({ patient, displaySetting, admin }: PatientTableDataProps): JSX.Element => {
    if (!patient) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }
    const vm = new PatientViewModel(patient)

    const createCells = useMemo(() => {
        return (
            <>
                <TableCell>{patient.id}</TableCell>
                <TableCell>{patient.code}</TableCell>
                <TableCell>
                    {!admin ? (
                        <div style={{ filter: 'blur(6px)', userSelect: 'none' }}>
                            <div style={{ fontSize: 11 }}>くらいふ たろう</div>
                            蔵井 不太郎
                        </div>
                    ) : (
                        vm.fullNameView()
                    )}
                </TableCell>
                <TableCell align="center">{patient.sampleCount}</TableCell>
                <TableCell align="center">{vm.gender()}</TableCell>
                <TableCell align="center">{vm.age()}</TableCell>
                <TableCell align="center">{!admin ? <div style={{ filter: 'blur(6px)', userSelect: 'none' }}>1900/01/01</div> : vm.birthdayText()}</TableCell>
                <TableCell>
                    {!admin ? (
                        <div style={{ filter: 'blur(6px)', userSelect: 'none' }}>
                            <div>〒000-0000</div>
                            <div>
                                東京都千代田
                                {new Array((vm.fullNameKana().length % 3) + 1)
                                    .fill(0)
                                    .map((_) => '残念ダミーです')
                                    .join(' ')}
                            </div>
                        </div>
                    ) : (
                        vm.addressVm().wholeView()
                    )}
                </TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
